import { render, staticRenderFns } from "./ListPermissionDialog.vue?vue&type=template&id=5aac4d60&"
import script from "./ListPermissionDialog.vue?vue&type=script&lang=js&"
export * from "./ListPermissionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports